import { FileDataProps } from "@/services";

export const getBase64 = (
  file: File,
  callback: (result: string | ArrayBuffer | null) => void,
) => {
  const reader = new FileReader();

  reader.onload = fileLoadedEvent => {
    const result = fileLoadedEvent?.target?.result as string;

    callback(result);
  };
  reader.onerror = error => {
    // eslint-disable-next-line no-console
    console.error(error);
  };
  reader.readAsDataURL(file);
};

const getMimeTypeByExtension = (extension: string): string => {
  const ext = extension.trim().toLowerCase().replace(/^\./, "");

  const mimeTypes: Record<string, string> = {
    pdf: "application/pdf",
    txt: "text/plain",
    html: "text/html",
    htm: "text/html",
    json: "application/json",
    csv: "text/csv",
    xml: "application/xml",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    mp3: "audio/mpeg",
    mp4: "video/mp4",
    zip: "application/zip",
  };

  return mimeTypes[ext] ?? "application/octet-stream";
};

export const saveBase64ToFile = (file: FileDataProps, isTemplate?: boolean) => {
  const _base64 = file.base64 as string;
  const isFullBase64 = _base64.startsWith("data:");

  // eslint-disable-next-line no-console
  console.info("isTemplate", isTemplate);

  /* eslint-disable */
  const url = isFullBase64
    ? _base64
    : // : !isTemplate
      // ? atob(_base64)
      `data:${getMimeTypeByExtension(file.type)};base64,${_base64}`;
  /* eslint-enable */

  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url as string;
  a.download = file.name;

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
};
